import { render } from "./RecuperarSenha.vue?vue&type=template&id=4529547a&scoped=true&ts=true"
import script from "./RecuperarSenha.vue?vue&type=script&lang=ts"
export * from "./RecuperarSenha.vue?vue&type=script&lang=ts"

import "./RecuperarSenha.vue?vue&type=style&index=0&id=4529547a&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4529547a"]])

export default __exports__